<nz-result
    nzStatus="403"
    nzTitle="Sorry, you are not authorized to access this page."
    nzSubTitle="You do not have sufficient permissions to access this page. If you feel this is incorrect, please contact the system administrator">
    <div nz-result-extra>
        <button nz-button nzType="primary" (click)="authService.signOut()">Sign Out</button>
    </div>
</nz-result>